// پیام‌رسانِ کوچک بینِ بخش‌های برنامه — مثلاً «پروفایلِ این مشاور را باز کن» از داخلِ ریلز (که خودش داخلِ
// اکسپلور/ذخیره‌شده‌ها/لینکِ اشتراکی باز شده) به App
const listeners = new Set();

export function openProfile(owner) {
  if (!owner || owner.id == null) return;
  listeners.forEach((fn) => fn(owner));
}

export function onOpenProfile(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

// شماره‌ی موبایل برای نمایش (۰۹۱۲ ۳۴۵ ۶۷۸۹ با رقمِ فارسی) و برای لینکِ تماس (tel:)
export function phoneText(phone) {
  const p = String(phone || '').replace(/\D/g, '');
  const parts = p.length === 11 ? [p.slice(0, 4), p.slice(4, 7), p.slice(7)] : [p];
  return parts.join(' ').replace(/\d/g, (d) => '۰۱۲۳۴۵۶۷۸۹'[d]);
}
export const telHref = (phone) => `tel:${String(phone || '').replace(/[^\d+]/g, '')}`;

// دکمه‌ی «برگشت»ِ گوشی برای لایه‌های روی هم (ریلز ← ورود به خانه، پروفایلِ مشاور ← ریلز ← …): هر لایه یک قدم در
// تاریخچه می‌گذارد با شماره‌ی عمقش؛ «برگشت» فقط بالاترین لایه را می‌بندد
export function pushBackLayer(onBack) {
  const layer = ((window.history.state && window.history.state.khLayer) || 0) + 1;
  let pushed = true;
  window.history.pushState({ khLayer: layer }, '');
  const onPop = (e) => {
    const cur = (e.state && e.state.khLayer) || 0;
    if (cur >= layer) return;
    pushed = false;
    window.removeEventListener('popstate', onPop);
    onBack();
  };
  window.addEventListener('popstate', onPop);
  return () => {
    window.removeEventListener('popstate', onPop);
    if (pushed) window.history.back();
  };
}
